/**
 * Column definitions for Outbound and Bank Response transmission tables.
 */
import Badge from '@cloudscape-design/components/badge';
import Button from '@cloudscape-design/components/button';
import StatusIndicator from '@cloudscape-design/components/status-indicator';
import { CopyableText } from 'src/components/common/CopyableText';

/** Renders a beacon state as a StatusIndicator. */
const renderStateIndicator = (state: string | null) => {
  if (state === 'SUCCESS') return <StatusIndicator type="success">{state}</StatusIndicator>;
  if (state === 'FAILED') return <StatusIndicator type="error">{state}</StatusIndicator>;
  return <StatusIndicator type="in-progress">{state || 'UNKNOWN'}</StatusIndicator>;
};

/** Outbound tab columns (PAIN_001 transmissions). */
export const getOutboundColumns = (selectedArn: string | null, onToggleDetails: (item: any) => void) => [
  { id: 'fileName', header: 'File Name', cell: (item: any) => <CopyableText value={item.fileName || '-'} /> },
  { id: 'executionArn', header: 'Execution ARN', cell: (item: any) => <CopyableText value={item.executionArn || '-'} /> },
  { id: 'bank', header: 'Bank', cell: (item: any) => item.bank || '—' },
  { id: 'state', header: 'State', cell: (item: any) => renderStateIndicator(item.beaconTransmissionState) },
  { id: 'actions', header: '', cell: (item: any) => (
    <Button
      variant="inline-link"
      disabled={item.executionArn == null}
      onClick={() => onToggleDetails(item)}
    >
      {selectedArn != null && selectedArn === item.executionArn ? 'Hide' : 'Details'}
    </Button>
  )},
];

/** Bank Responses tab columns (non-PAIN_001 transmissions + bankResponses map). */
export const getBankResponseColumns = (selectedArn: string | null, onToggleDetails: (item: any) => void) => [
  { id: 'type', header: 'Type', cell: (item: any) => <Badge color="blue">{item.type}</Badge> },
  { id: 'fileName', header: 'File Name', cell: (item: any) => <CopyableText value={item.fileName || '-'} /> },
  { id: 'executionArn', header: 'Execution ARN', cell: (item: any) => <CopyableText value={item.executionArn || '-'} /> },
  { id: 'bank', header: 'Bank', cell: (item: any) => item.bank || '—' },
  { id: 'state', header: 'State', cell: (item: any) => renderStateIndicator(item.beaconTransmissionState) },
  { id: 'responseCode', header: 'Response Code', cell: (item: any) => item.responseCode || '—' },
  { id: 'actions', header: '', cell: (item: any) => (
    <Button
      variant="inline-link"
      disabled={item.executionArn == null}
      onClick={() => onToggleDetails(item)}
    >
      {selectedArn != null && selectedArn === item.executionArn ? 'Hide' : 'Details'}
    </Button>
  )},
];
